import { render, staticRenderFns } from "./NuevaLicencia.vue?vue&type=template&id=539c1ec8&"
import script from "./NuevaLicencia.vue?vue&type=script&lang=js&"
export * from "./NuevaLicencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports